export const activitiesToTry = {
  title: 'Activities to try',
  happy: `
    <p>The
    <a
      rel="noopener"
      href="https://dementiatogether.online/"
      target="_blank"
      title="Connecting People, Connecting Support"
      >Connecting people, connecting support</a
    >
    website is a space where people with dementia, families and
    supporters can explore ways of living well with dementia.It includes
    activities, information and useful links.
    </p>
    
    <p>
    Talk about your feelings. Do activities you enjoy such as listening
    to music or reading books.
    </p>
    
    <p>
    <a
      rel="noopener"
      href="https://www.playlistforlife.org.uk/"
      target="_blank"
      title="Playlist for Life"
    >
      Playlist for life</a
    >
    is a resource designed specifically for people experiencing
    dementia.It helps you to find, store and listen to music that you
    like and that is personally meaningful to you.
    </p>
    <p>
    Pull out some old photos and reminisce about good times.
    </p>
    `,
  relaxed: `<p>Suggestions of things that you can do within your home environment can be found at <a rel="noopener"
    href="https://dementiatogether.online/home-environment-try" target="_blank"
    title="Dementia Together: home environment">Dementia Together: home environment</a>.</p>
  <p>Spending time in nature or even just going outside can boost wellbeing and help you feel more relaxed. You could
  visit a favourite park or outdoor space that you are familiar with.</p>
  <p>Stress and anxiety are a normal part of life and learning some relaxation or breathing techniques can help you to
  stay calm in difficult situations. Information and guidance on breathing techniques and relaxation can be found at
  <a rel="noopener" href="https://dementiatogether.online/relaxation-more" target="_blank"
    title="Dementia Together: more relaxation">Dementia Together: more relaxation</a>.
  </p>
  <p>Information about meditation and mindfulness can be found at <a rel="noopener"
    href="https://blog.calm.com/take-a-deep-breath" target="_blank"
    title="Calm blog: let's look after ourselves and each other">Let’s look after ourselves, and each other. — Calm
    Blog</a>.</p>` ,
  active: `<p><strong>Eating and Drinking</strong></p>
    <p>Eating and drinking well can help your body to fight infection and illness, and boosts your overall wellbeing. It
        will enable you to maintain healthy muscles and bones, helping you to stay mobile, whilst reducing your risk of
        falls and fractures.</p>
    <p>It is important that you drink plenty of fluids to keep your body hydrated. Being dehydrated can make people feel
        confused. Try to drink plenty of water and other fluids in addition to any tea and coffee you drink.</p>
    <p><strong>Smoking</strong></p>
    <p>Consider limiting or stopping smoking. If you are unable to stop, consider changing to vape. Smoking increases the
        risk of dementia progressing. It has also been known to lead to risk of accidental fires due to unattended
        cigarettes.</p>
    <p><strong>Alcohol</strong></p>
    <p>Too much alcohol can cause confusion and increase your risk of falls.</p>
    <p>If you are diagnosed with dementia, your overall ability to manage alcohol consumption may be reduced. You might be
        prone to becoming intoxicated at smaller quantities of alcohol. It would be advisable to cut down how much and how
        often you drink alcohol, as it can make dementia symptoms worsen.</p>
    <p>If you have a type of dementia related to alcohol use, it is very important not to drink alcohol because it may make
        you symptoms worse.</p>
    <p>Check with your doctor whether it is all right to drink alcohol.</p>
    <p>Do not abruptly stop drinking alcohol but consult with your doctor to get professional help.</p>
    <p><strong>Physical activity </strong></p>
    <p>Keeping physically active is important for everyone. Physical activity is important for maintaining fitness and
        keeping muscles and joints flexible. There are also benefits for your mental health and it can help you get a better
        night's sleep.</p>
    <p>Physical activity includes all forms of activity where you move your body. It includes exercise or sport such as
        cycling or running. It also includes things like, dance, gardening and even housework. Whatever your starting point,
        doing a bit more activity will help you feel good.</p>
    <p><strong>Looking after your physical health</strong></p>
    <p>Looking after your feet is important to help you stay mobile.</p>
    <p>Get your vision and hearing checks regularly to help you get the best out of life.</p>
    <p><strong>Websites</strong></p>
    <p>Allied health professionals have worked with Alzheimer Scotland to provide information about <a rel="noopener"
            href="https://www.alzscot.org/ahpresources" target="_blank"
            title="Looking after your physical health and wellbeing.">looking after your physical health and wellbeing</a>.
    </p>
    <p>You could also try the <a rel="noopener" href="https://www.nhsinform.scot/healthy-living" target="_blank"
            title="NHS inform Healthy living site">NHS
            inform Healthy living site</a></p>` ,
  rested: `<p>Try to avoid napping during the day, go to bed and get up at the same time each day and avoid having a lie in.</p>
  <p>Being active during the day can help you to be ready for sleep at night. Avoid caffeine, alcohol or cigarettes in the
      evening.</p>
  <p>Ensure your room is cool and dark and have a relaxing bed time routine that includes reading a book, meditation or
      having a bath.</p>
  <p>Follow these links for more information and help: </p>
  <ul>
      <li><a rel="noopener" href="https://dementiatogether.online/home/sleep1" target="_blank"
              title="Dementia Together Online">Connecting People, Connecting Support: sleep</a></li>
      <li><a rel="noopener"
              href="https://www.nhsinform.scot/healthy-living/mental-wellbeing/five-steps-to-mental-wellbeing#mindfulness-for-mental-wellbeing"
              target="_blank" title="NHS Inform: mindfulness for mental wellbeing">NHS inform: f</a><a rel="noopener"
              href="https://www.nhsinform.scot/healthy-living/mental-wellbeing/five-steps-to-mental-wellbeing#mindfulness-for-mental-wellbeing"
              target="_blank" title="NHS Inform: mindfulness for mental wellbeing">ive steps to mental wellbeing:
              mindfulness for mental wellbeing</a></li>
      <li><a rel="noopener"
              href="https://www.nhsinform.scot/illnesses-and-conditions/mental-health/insomnia#self-help-tips"
              target="_blank" title="NHS Inform: self help tips for insomnia">NHS Inform self-help tips for sleeping
              well</a></li>
      <li><a rel="noopener" href="https://www.mentalhealth.org.uk/a-to-z/m/mindfulness" target="_blank"
              title="Mental Health Foundation: mindfulness">Mental Health Foundation: mindfulness</a></li>
  </ul>`,
  interests: `<p>It could be helpful to write a list of things you like to do or interest you.</p>
  <p>There is an <a rel="noopener"
          href="https://www.alzscot.org/sites/default/files/2020-04/Activities%20at%20home%20v5.pdf" target="_blank"
          title="Alzheimer Scotland Activities at Home checklist">activities checklist from Alzheimer Scotland</a> you can
      use that could help.</p>
  <p>The <a rel="noopener" href="https://dementiatogether.online/" target="_blank"
          title="Connecting People, Connecting Support">Connecting
          People, Connecting Support website</a> lists activities that people with dementia might find helpful.</p>
  <p>Board games, puzzles or crosswords help keep your mind active. Hobbies such as writing, painting, crafts or knitting
      can bring enjoyment and help you to relax.</p>
  <p>Social connections are important for all of us, try to stay connected with community or faith groups and keep in
      touch with friends and family.</p>`,
}

export default activitiesToTry;
